import { useMemo } from "react";
import getPermissionPrefixByType from "util/getPermissionPrefixByType";
import { getValuesFromGRN } from "logic/permissions/GRN";
import usePermissions from "hooks/usePermissions";
const useHasEntityPermissionByGRN = (grn, permissionType = "read") => {
  const { id, type } = getValuesFromGRN(grn);
  const { isPermitted } = usePermissions();
  return useMemo(
    () => isPermitted(`${getPermissionPrefixByType(type, id)}${permissionType}:${id}`),
    [id, permissionType, isPermitted, type]
  );
};
export default useHasEntityPermissionByGRN;
